import { AfterViewInit, Component, inject, Input, OnInit } from '@angular/core';
import { EventsService, GalleryService, UtilService, VariablesService, VwoService } from '../../../../shared/services';
import { IUser } from 'src/app/shared/models';
@Component({
  selector: 'app-document',
  templateUrl: './document.component.html',
  styleUrls: ['./document.component.scss']
})
export class DocumentComponent implements OnInit, AfterViewInit {

  @Input() public documents;
  @Input() public sharedCounts;
  @Input() public fundraiser;
  @Input() public isFundraiserEnded;
  @Input() public basicInfo;
  @Input() position = '';
  defaultImg;
  userData: IUser;
  public vwo = inject(VwoService);
  public util = inject(UtilService);
  public vars = inject(VariablesService);
  openLoginPopup = false;

  constructor(
    private events: EventsService,
    public utilService: UtilService,
    private galleryService: GalleryService
  ) { }

  ngOnInit() {
    this.defaultImg = this.utilService.defaultImg;
    this.vars.userData.subscribe({
      next: (val: IUser) => {
        this.userData = val;
      }
    });
  }
  ngAfterViewInit() {
    setTimeout(() => {
      this.galleryService.initGallery('lightgalleryDocs');
    }, 0);
  }

  signinClosed() {
    this.openLoginPopup = false;
  }

  imgClick(item) {
    const ePayload = {
      eventName: 'galary_img_click',
      info_1: this.position
    };
    this.events.sendSystemEvent(ePayload).subscribe(_ => _);
  }
}
